import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class SlugService {
    private slug = signal('start');

    set setSlug(slug: string) {
        this.slug.set(slug);
    }

    get getSlug() {
        return this.slug;
    }

    isHome() {
        return this.slug() === 'home';
    }
}
